import { ErrorPage } from '@/pages/ErrorPage'

/** Adapts mountL3App's `{ error, resetError }` fallback shape to ErrorPage's `{ detail, onReset }` props. */
export function ErrorFallback({
  error,
  resetError,
}: {
  error: unknown
  resetError: () => void
}) {
  return (
    <ErrorPage
      detail={import.meta.env.DEV ? (error as Error).message : undefined}
      onReset={resetError}
    />
  )
}
